import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculo-porcentaje',
  templateUrl: './calculo-porcentaje.component.html',
  styleUrls: ['./calculo-porcentaje.component.css']
})
export class CalculoPorcentajeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
